import moment from 'moment';

export function timeDiff(to, from) {
    let hourDiff = to.diff(from,'hours');
    let minuteDiff = to.diff(from,'minutes');
    let minuteDuration = minuteDiff % 60;

    return hourDiff + ' hours ' + minuteDuration + ' mins';
}

export function formatDateTime(value, field) {
    
     if (value[field])
        value[field] = moment(value[field]).format('DD/MM/YYYY HH:MM'); 
         
}

export function isDate(value) {
    var dt = new Date(value);
    return !isNaN(dt);
}

export function adjustForBST(date) {
    var d = new Date(moment.utc(date).toLocaleString())
    return d;
}